function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.636 6.807l-.552-.77-5.237 3.396L4.553 6 4 6.77 8.975 10 4 13.23l.553.77 10.982-7.127.101-.066zM10.807 11.193l4.277 2.77.552-.77-3.956-2.568-.873.568z",
  fill: "#fff"
});
function SvgRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default SvgRemove;